import { isElementVisible} from "@/utilities/domUtils";
import type {Directive, DirectiveBinding} from "vue";
import {set} from "lodash-es";
import type {VNode} from "@vue/runtime-core";

type OnVisibleNode = VNode<any, Element> & { nfprops: any};
/**
 * Dyrektywa która może uruchomić skrypt w momencie gdy element będzie widoczny
 */
export default <unknown>{
    mounted(el: Element, binding: DirectiveBinding, node: OnVisibleNode) {
        if(!node.nfprops) {
            node.nfprops = {
                elementIsVisible: false
            };
        } else {
            node.nfprops.elementIsVisible = false;
        }
        node.nfprops.intersectionObserver = new IntersectionObserver(
            //@ts-ignore
            binding.dir.onElementVisible.bind(binding.dir, binding.instance,node.nfprops, binding.value),
            {
                threshold: 0.1,
                // @ts-ignore
                delay: 0,
                trackVisibility: false
            });
        //@ts-ignore
        binding.dir.observeElement.apply(binding.dir, [el, node, binding]);
    },
    updated(el: Element, binding: DirectiveBinding, node: OnVisibleNode, prevVNode: OnVisibleNode) {
        if(prevVNode.nfprops?.intersectionObserver && !node.nfprops?.intersectionObserver) {
            //Kopiujemy właściwości do nowego noda w razie aktualizacji
            set(node, ['nfprops','elementIsVisible'], prevVNode.nfprops?.elementIsVisible || false);
            set(node, ['nfprops','intersectionObserver'], prevVNode.nfprops.intersectionObserver);
            set(node, ['nfprops','observedElement'], prevVNode.nfprops.observedElement);
            set(node, ['nfprops','observingIntervalId'], prevVNode.nfprops.observingIntervalId);
        }
        if (!node.nfprops) {
            node.nfprops = {
                elementIsVisible: false
            };
            node.nfprops.intersectionObserver = new IntersectionObserver(
                //@ts-ignore
                binding.dir.onElementVisible.bind(binding.dir, binding.instance,node.nfprops, binding.value),
                {
                    threshold: 0.1,
                    // @ts-ignore
                    delay: 0,
                    trackVisibility: false
                });
            //@ts-ignore
            binding.dir.observeElement.apply(binding.dir, [el, node, binding]);
        } else {
            if (node.nfprops) {
                //@ts-ignore
                if ((node.nfprops.observedElement != binding.dir.getRealElement.apply(binding.dir, [el]))
                || (node.nfprops.intersectionObserver && !node.nfprops.intersectionObserver.takeRecords().length)) {
                    //@ts-ignore
                    binding.dir.observeElement.apply(binding.dir, [el, node, binding]);
                }
            }
        }
    },
    unobserveElement(node: OnVisibleNode) {
        if (node.nfprops?.intersectionObserver) {
            if (node.nfprops.observedElement) {
                node.nfprops.intersectionObserver.unobserve(node.nfprops.observedElement);
            }
            if (node.nfprops.observingIntervalId) {
                window.clearInterval(node.nfprops.observingIntervalId);
            }
        }
    },
    getRealElement(el: Element) {
        let realElement = el;
        //Czasem Vue poda nam element typu text (nodeType == 1) jako główny element komponentu
        //To jest artefakt Vue
        //W takich wypadkach należy użyć nextElementSibling żeby znaleźć właściwy element.
        if (realElement.nodeType != 1 && realElement.nextElementSibling) {
            realElement = realElement.nextElementSibling;
        }
        if (realElement.nodeType == 1) {
            return realElement;
        }
        return el;
    },
    observeElement(el: Element, node: OnVisibleNode, binding: DirectiveBinding<any>) {
        let observingRetries = 5;
        let observingIntervalId = window.setInterval( () => {
            if (observingRetries-- == 0) {
                window.clearInterval(observingIntervalId);
            }
            if (node.nfprops?.intersectionObserver) {
                //@ts-ignore
                let realElement = this.getRealElement(node.el) as any;
                if (!realElement.intersectionObserver) {
                    node.nfprops.intersectionObserver.observe(realElement);
                    //@ts-ignore
                    realElement.elementIsObserved = true;
                    realElement.intersectionObserver = node.nfprops.intersectionObserver;
                    node.nfprops.observedElement = realElement;
                    if (node.nfprops.observingIntervalId) {
                        window.clearInterval(node.nfprops.observingIntervalId);
                    }
                    let retries = 5;
                    let intervalId: number;
                    intervalId = window.setInterval(() => {
                        //@ts-ignore
                        realElement = binding.dir.getRealElement.apply(binding.dir, [node.el]);
                        if (isElementVisible(realElement as HTMLElement)) {
                            //@ts-ignore
                            binding.dir.onElementVisible.apply(this, [binding.instance, node.nfprops, binding.value, null, realElement]);
                        } else {
                            //@ts-ignore
                            node.nfprops.elementIsVisible = false;
                            realElement.elementIsVisible = false;
                        }
                        if (retries-- == 0) {
                            window.clearInterval(intervalId);
                        }

                    }, 100);
                    node.nfprops.observingIntervalId = intervalId;
                }
            }
        }, 10);
    },
    onElementVisible(context:any,props:any,callback: Function, entries: IntersectionObserverEntry[], element?: Element) {
        if( entries && entries.length) {
            //@ts-ignore
            if(entries[0].isIntersecting || entries[0].isVisible) {
                if(!props['elementIsVisible']) {
                    props['elementIsVisible'] = true;
                    //@ts-ignore
                    entries[0].target.elementIsVisible = true;
                    if(typeof(callback) == 'function') {
                        callback(entries[0].target, context);
                    }
                }
            } else {
                props['elementIsVisible'] = false;
                //@ts-ignore
                entries[0].target.elementIsVisible = false;
            }
        } else if (!entries) {
            if(!props['elementIsVisible']) {
                props['elementIsVisible'] = true;
                if (element) {
                    //@ts-ignore
                    element.elementIsVisible = true;
                }
                if(typeof(callback) == 'function') {
                    callback(element, context);
                }
            }
        }
    },
    beforeUnmount( el: Element, binding: DirectiveBinding,node: OnVisibleNode) {
        if(!node.nfprops) {
            node.nfprops = {};
        }
        if(node.nfprops.intersectionObserver) {
            //@ts-ignore
            binding.dir.unobserveElement.apply(binding.dir, [node]);
            node.nfprops.intersectionObserver.disconnect();
            delete node.nfprops.intersectionObserver;
        }
    }


} as Directive<Element> ;